import { AudioRecordingModelData } from "@/store/audio-recordings";
import { AudioRecordingProcessingStatus } from "@/store/audio-recordings/types";
import {
  BaseAudioRecordingAppEventOperation,
  BaseAudioRecordingAppEventOperationParams,
} from "./BaseAudioRecordingAppEventOperation";

/**
 * Operation to mark that an audio recording encountered an unexpected error.
 * This is used for non-transform errors like missing note ID, note not found, etc.
 */
export class MarkUnexpectedErrorAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind() {
    return "MARK_UNEXPECTED_ERROR_AUDIO_RECORDING" as const;
  }

  constructor(params: BaseAudioRecordingAppEventOperationParams) {
    super(params);
  }

  protected getModelDataUpdates(
    _existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    return {
      processing_status: AudioRecordingProcessingStatus.ERROR,
    };
  }
}
